import { Divider, EmptyState } from "@chr/eds-react";
import { Box, Stack, useTheme } from "@mui/material";

export interface DrawerSuccessSummaryProps {
  title: string;
  subTitle: string;
  againButtonText: string;
  onAgain: (event: object) => void;
  children: React.ReactNode;
}

export const DrawerSuccessSummary = ({
  title, 
  subTitle, 
  againButtonText, 
  onAgain, 
  children
}: DrawerSuccessSummaryProps) => {
  const theme = useTheme();

  return (
    <Stack spacing={4}>
      <Box sx={{ '.MuiContainer-root':{ padding:0 }}}>
        <EmptyState 
          illustration="none"
          subtitle={title}
          description={subTitle}
          secondaryAction={{
            buttonText:againButtonText,
            onClick:onAgain
          }}
        />
      </Box>
      <Divider />
      <Box
        padding={2} 
        bgcolor={theme.palette.grey[50]}
        borderRadius={1}
      >
        {children}
      </Box>
    </Stack>
  );
}